<div class="card bg-card-new card-radius-x1 border-0">
    <div class="card-header">
        <h5>{{"change_password"|translate}}</h5>
    </div>
    <div class="card-divider"></div>
    <div class="card-body">
        <form [formGroup]="form">
        <div class="row no-gutters">
            <div class="col-12 col-lg-7 col-xl-6">
                <div class="form-group required">
                    <label class="control-label" for="password-current">{{"current_password"|translate}}</label>
                    <input type="password" formControlName="oldPassword" class="form-control" id="password-current" [attr.placeholder]="'current_password'|translate">
                </div>
                <div class="form-group required">
                    <label class="control-label" for="password-new">{{"new_password"|translate}}</label>
                    <input type="password" formControlName="password" class="form-control" id="password-new" [attr.placeholder]="'new_password'|translate">
                </div>
                <div class="form-group required">
                    <label class="control-label" for="password-confirm">{{"confirm_new_password"|translate}}</label>
                    <input type="password" formControlName="confirmPassword" class="form-control" id="password-confirm" [attr.placeholder]="'confirm_new_password'|translate">
                </div>

                <div class="form-group mt-5 mb-0">
                    <button class="btn btn-primary" (click)="submit()">{{"change"|translate}}</button>
                </div>
            </div>
        </div>
    </form>
    </div>
</div>
